import React from 'react';
import { Grid, Paper, makeStyles, List, ListSubheader, IconButton, ListItem, CircularProgress } from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import File from './File';

function Files(props) {
    const classes = useStyles();

    const { files, to, uploadFile, deleteFile, isLoading, updateFile } = props

    const handleFileSubmit = header => event => {
        event.preventDefault();
        var formData = new FormData();
        formData.append("folder", header)
        for (let i = 0; i < event.target.files.length; i++) {
            formData.append("files", event.target.files[i])
        }
        uploadFile(formData)
    }

    const handleFileDelete = (id) => (event) => {
        deleteFile(id)
    }

    const clearInput = event => {
        event.target.value = ''
    }

    return (
        <Paper className={classes.paper} square>
            <form>
                <List dense={true} style={{ padding: 0 }}>
                    {isLoading ?
                        <CircularProgress />
                        :
                        files.map(({ header, items }, i) =>
                            <div key={i}>
                                <ListSubheader component="div" className={classes.header}>
                                    <Grid
                                        justify="space-between"
                                        container
                                    >
                                        <Grid item className={classes.headerText}>
                                            {header}
                                        </Grid>
                                        <Grid>
                                            <IconButton
                                                variant="contained"
                                                component="label"
                                                onClick={clearInput}
                                            >
                                                <AddBoxIcon />
                                                <input
                                                    multiple
                                                    type="file"
                                                    style={{ display: "none" }}
                                                    onChange={handleFileSubmit(header)}
                                                />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </ListSubheader>
                                {
                                    items.length === 0 ?
                                        <ListItem className={`${classes.emptyText} ${classes.listText}`}>
                                            Ce dossier est vide
                                        </ListItem>
                                        :
                                        items.map(item =>
                                            <File key={item.id} item={item} to={to} handleFileDelete={handleFileDelete} handleFileUpdate={updateFile} />
                                        )
                                }
                            </div>
                        )
                    }
                </List>
            </form>
        </Paper>
    )
}

export default Files;

const useStyles = makeStyles(theme => ({
    paper: {
        textAlign: 'center',
        overflow: 'auto',
        maxHeight: '640px'
    },
    header: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        backgroundColor: '#e8eaf6',
    },
    headerText: {
        fontSize: 16
    },
    emptyText: {
        color: 'rgba(0, 0, 0, 0.54)'
    }
}));